import styled from 'styled-components'
import { Row, notClickableCSS } from 'components/common'

const Content = styled.div`
  display: none;
  position: absolute;
  top: 55px;
  right: 2px;
  background-color: #f9f9f9;
  min-width: 200px;
  z-index: 1060;
  font-size: 14px;
  color: black;
  margin-top: -5px;
  margin-left: -15px;
  flex-direction: column;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
`

const Container = styled(Row)`
  display: flex;
  margin-right: 8px;

  &:hover ${Content} {
    display: flex;
  }
  &:hover {
    cursor: pointer;
  }

  & > svg {
    color: #ddd;
  }
  &:hover > svg {
    color: #fff;
  }
`

const Item = styled.div`
  color: black;
  /*     padding: 0px 14px; */
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 4px 12px;

  white-space: nowrap;
  ${notClickableCSS}
`

const InitialsAvatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #666;
  color: #fff;
  font-size: 12px;
  border-radius: 50%;
  height: 32px;
  width: 32px;
  margin-right: 12px;
  font-weight: 600;
`

export { Container, Content, Item, InitialsAvatar }
